const styles = theme => ({
  root: {
    display: 'flex',
    borderBottom: '1px solid rgba(12,31,44,0.12)',
    paddingBottom: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    '&:last-child': {
      borderBottom: 0,
      marginBottom: 0,
      paddingBottom: 0
    }
  },
  iconContainer: {
    marginRight: theme.spacing.unit * 2.625
  },
  icon: {
    color: 'rgba(12,31,44,0.38)'
  },
  eProName: {
    marginBottom: [theme.spacing.unit * 0.5, '!important']
  },
  menuItemRoot: {
    color: 'rgba(12,31,44,0.87)',
    fontFamily: 'Roboto',
    fontSize: '14px',
    letterSpacing: '0.15px',
    lineHeight: '20px',
    backgroundColor: '#FFF !important',
    height: '40px',
    padding: [[0, theme.spacing.unit * 2]],
    '&:hover': {
      backgroundColor: 'whitesmoke !important'
    }
  },
  menuItemSelected: {
    backgroundColor: '#ebebeb !important'
  },
  optionsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 48
  },
  optionsButton: {
    position: 'relative',
    right: -14
  },
  optionsIcon: {
    transform: 'rotate(90deg)',
    color: theme.palette.primary.main
  },
  disabled: {
    color: [theme.palette.disabled.main, '!important']
  },
  details: {
    flex: 1
  }
});

export default styles;
